import React from "react";

function Loader() {
  return (
    <div className="absolute flex items-center justify-center bg-slate-200/20 inset-0  backdrop-blur-sm">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
